import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  removeButton: {
    position: 'absolute',
    right: -8,
    top: 5,
    zIndex: 2,
  },
});

export default styles;
